import { useEffect, useState, useCallback } from "react";
import { Typography, Button, CircularProgress } from "@mui/material";
import BasicTable from "../Table/Material";
import useApi from "../../Hooks/useApi";
import useWindowWidth from "../../Hooks/useWindowWidth";
import useWindowHeight from "../../Hooks/useWindowHeight";
import Modal from ".";
import ConfirmModal from "./ConfirmModal";
import showToast from "../../Helpers/toast";

const IMISDataInsertionModal = ({ imis, onClose }) => {
  const { city, year, status } = imis;
  const { request, loading } = useApi();
  const windowHeight = useWindowHeight();

  const [imisIndicatorsData, setImisIndicatorsData] = useState([]);
  const [error, setError] = useState(null);

  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const [publishModalOpen, setPublishModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const windowWidth = useWindowWidth();

  const columns = [
    {
      id: "cwisCode",
      label: "CWIS Code",
      minWidth: 100,
      align: "left",
    },
    {
      id: "indicator",
      label: "Indicator",
      minWidth: 170,
      align: "left",
    },
    {
      id: "value",
      label: "Value",
      minWidth: 170,
      align: "center",
    },
  ];

  const fetchIMISIndicators = useCallback(async () => {
    try {
      const response = await request(
        "GET",
        `/v1/imis/indicators/${city}/${year}`,
        {},
        "external_service"
      );
      const indicators = response.indicators;

      const res = indicators.map((indicator) => ({
        indicator: indicator.name,
        value: indicator.value,
        cwisCode: indicator.cwisCode,
        status: indicator.status, // Assuming the API returns a status field
      }));

      setImisIndicatorsData(res);
      setError(null);
    } catch (error) {
      console.error("Error fetching IMIS indicators:", error);
      setError("Failed to fetch IMIS indicators. Please try again later.");
    }
  }, [city, year, request]);

  useEffect(() => {
    fetchIMISIndicators();
  }, [fetchIMISIndicators]);

  const handlePublish = () => {
    // Implement publish functionality here
    setConfirmOpen(true);
  };

  const handleCloseModal = () => {
    setConfirmOpen(false);
    onClose();
    setPublishModalOpen(false); // Close the modal
  };
  const handleConfirmModal = () => {
    updateStatus();
  };

  const updateStatus = async () => {
    try {
      const response = await request(
        "PUT",
        `/v1/imis/indicators/status`,
        { data: { cityName: city, year: year } },
        "external_service"
      );

      // Update state to disable publish button immediately
      handleCloseModal();

      setModalMessage(response);
    } catch (error) {
      console.log("error", error);
      setPublishModalOpen(false);
      showToast({ message: error?.response?.data?.message, type: "error" });
    }
  };

  return (
    <div className="relative">
      <div className="text-center mb-5">
        <Typography variant="h4" component="p" className="font-bold">
          IMIS Indicators Data
        </Typography>
        <Typography variant="h5" component="p" className="font-bold">
          {city} - {year}
        </Typography>
      </div>

      {loading ? (
        <div className="text-center">
          <CircularProgress size={24} />
          <Typography variant="body1" component="span" className="ml-2">
            Loading...
          </Typography>
        </div>
      ) : error ? (
        <Typography variant="body1" color="error" className="text-center">
          {error}
        </Typography>
      ) : imisIndicatorsData.length === 0 ? (
        <Typography variant="body1" className="text-center text-lg">
          No data available
        </Typography>
      ) : (
        <>
          <BasicTable
            style={{ width: "100%", marginRight: "auto", marginLeft: "auto" }}
            maxHeight={Math.max(windowHeight * 0.4, 100)}
            columns={columns}
            data={imisIndicatorsData}
          />
          {status !== "PUBLISHED" && (
            <div className="text-center mt-4">
              <Button
                variant="contained"
                color="primary"
                onClick={() => handlePublish()}
              >
                Publish Data
              </Button>
            </div>
          )}
        </>
      )}
      <ConfirmModal
        isOpen={isConfirmOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmModal}
        label={"Are you sure, you want to publish this data?"}
        style={{ width: windowWidth >= 768 ? "50vw" : "90vw" }}
      />
      <Modal
        isOpen={publishModalOpen}
        onClose={handleCloseModal}
        style={{ width: windowWidth >= 768 ? "50vw" : "90vw" }}
      >
        <div>
          <p className="text-green-500 text-center font-bold pt-4 ">
            {modalMessage[0]?.toUpperCase() +
              modalMessage?.slice(1, modalMessage?.length)}
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default IMISDataInsertionModal;
